__turbopack_context__.v({
  "panelContent": "tabItemsContent-module-scss-module__OTTGyG__panelContent",
  "panelContentWrapper": "tabItemsContent-module-scss-module__OTTGyG__panelContentWrapper",
  "panelText": "tabItemsContent-module-scss-module__OTTGyG__panelText",
  "tabContentTitle": "tabItemsContent-module-scss-module__OTTGyG__tabContentTitle",
  "tabCta": "tabItemsContent-module-scss-module__OTTGyG__tabCta",
  "tabCtaContainer": "tabItemsContent-module-scss-module__OTTGyG__tabCtaContainer",
});
